import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class UnibankPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  accessKey: string;
  customerId: string;
  transactionId: string;
  // postBackUrl: string;

   invoiceField: string;
  customerField: string;
  locationField: string;
  descriptionField: string;
  providerSettings?: any;

  constructor(options?: Partial<UnibankPaymentProcessorAccountConfiguration>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}